import Grid from './Grid';
import debounce from 'debounce';

export default {
	mixins: [Grid],
	props: {
		filters: {
			type: Object,
			default: () => ({}),
		}
	},
	methods: {
		debounceReload() {},
	},
	watch: {
		filters: {
			deep: true,
			handler() {
				this.debounceReload();
			}
		}
	},
	created() {
		//Set this during component creation to avoid multiple components sharing the same debounce
		this.debounceReload = debounce(function() {
			this.load();
		}, 250);
	}
}
